import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sample-code-and-sdks"
    }}>{`Sample code and SDKs`}</h1>
    <h2 {...{
      "id": "stock-api-sdks"
    }}>{`Stock API SDKs`}</h2>
    <p>{`Adobe Stock created SDK libraries to simplify the process of writing applications which consume the Stock APIs. These libraries act as "wrappers" around the Stock API methods, allowing the developers to call functions in their app that do the work of communicating with the Stock servers. This should minimize the risk of errors, and also speed up the time required to finish the application.`}</p>
    <p>{`Adobe offers an SDK for PHP. It is hosted as open source software by Adobe on GitHub.`}</p>
    <p>{`Get the SDKs here:
`}<a parentName="p" {...{
        "href": "https://github.com/adobe/stock-api-sdk"
      }}>{`https://github.com/adobe/stock-api-sdk`}</a></p>
    <h2 {...{
      "id": "stock-sample-code"
    }}>{`Stock sample code`}</h2>
    <p>{`The examples demonstrate how to use the Stock SDKs as well as how to generate service tokens.`}</p>
    <p>{`Examples:
`}<a parentName="p" {...{
        "href": "https://github.com/adobe/stock-api-samples"
      }}>{`https://github.com/adobe/stock-api-samples`}</a></p>
    <h3 {...{
      "id": "stock-gallery-helper"
    }}>{`Stock Gallery Helper`}</h3>
    <p>{`The Stock Gallery Helper is an experimental extension for Chrome to manage Stock galleries/collections using the API. This sample code is a work in progress.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/adobe/stock-api-samples/tree/master/StockGalleryHelper"
      }}>{`https://github.com/adobe/stock-api-samples/tree/master/StockGalleryHelper`}</a></p>
    <h3 {...{
      "id": "stock-searchbar-sample-app"
    }}>{`Stock SearchBar sample app`}</h3>
    <p>{`When dropped into your page, this sample library creates a gallery of Stock search thumbnails. While you can add different search parameters, its primary purpose is to search on a similar image URL (such as the main image on your page), or on keywords. This sample code includes a live demo.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/adobe/stock-api-samples/tree/master/stockthumbs"
      }}>{`https://github.com/adobe/stock-api-samples/tree/master/stockthumbs`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      